// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T2TP1CpRdGI3Y9 {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  border: none;
  border-radius: var(--ds-border-radius-200, 8px);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.T2TP1CpRdGI3Y9:hover {
  background-color: var(--ds-background-neutral, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.k0Arr5f0RJjAbB {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--ds-space-050, 4px);
  gap: var(--ds-space-100, 8px);
}
.tkFWG8XBC6r7o0 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 30px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.V1G6io2O1mvr45 {
  flex: 1;
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 18px;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `T2TP1CpRdGI3Y9`,
	"details": `k0Arr5f0RJjAbB`,
	"icon": `tkFWG8XBC6r7o0`,
	"title": `V1G6io2O1mvr45`
};
export default ___CSS_LOADER_EXPORT___;
